module.exports = __webpack_public_path__ + "img/SacredDeer64_ua.27cc8900.webp";